import { ChangeEvent } from 'react';
import { Form } from 'semantic-ui-react';
import {
	getValidationLabelProps,
	ValidationLabelProps,
} from 'src/components/elements/form-inputs/ValidationLabelProps';

export const SimpleInput = (field: any) => {
	const { t, maxChars, input, label, meta, hideLabel, hint, ...rest } = field;
	const validationLabelProps: ValidationLabelProps = getValidationLabelProps(meta, label);

	const remainingChars = maxChars - input.value.length < 0 ? 0 : maxChars - input.value.length;
	const maxCharHint =
		typeof maxChars === 'number' && !validationLabelProps.isError && maxChars > 100 && remainingChars <= 100
			? t('characters_remaining', { characters: remainingChars, max: maxChars })
			: undefined;

	const labelWithHint =
		hint != null || maxCharHint != null ? (
			<label>
				{validationLabelProps.label}
				<span style={{ color: 'gray', fontWeight: 'normal' }}>
					{hint} {maxCharHint}
				</span>
			</label>
		) : (
			validationLabelProps.label
		);

	return (
		<Form.Input
			step={input.type === 'number' ? 'any' : undefined}
			{...input}
			label={hideLabel ? undefined : labelWithHint}
			error={validationLabelProps.isError}
			icon={validationLabelProps.icon}
			{...rest}
			onChange={(event: ChangeEvent<HTMLInputElement>) => {
				input.onChange?.(event);
				rest.onChange?.(event);
			}}
		/>
	);
};
